/** Default visualization / side-panel copy for Knowledge Agent (and DEA) create flow. */
export const KA_VISUALIZATION_DEFAULTS = Object.freeze({
  title: `Hi there 👋 I'm your event assistant. How can I help?`,
  placeholder: 'How can I help you today?',
  buttonText: 'Ask',
  feedbackLabel: 'Did we answer your question?',
  fabButtonText: 'Chat with Us',
  fabTooltip: '',
  footerIsActive: true,
  engagementFooterText:
    "You're chatting with an AI-powered event assistant. Responses are generated automatically using event resources and may occasionally be inaccurate.",
  /** Brand font — used when no dynamic font is configured. */
  fontFamily: 'Plus Jakarta Sans',
  shinyBorder: Object.freeze({
    isActiveFab: true,
    isActiveBottomBar: true,
    color1: '#7c3aed',
    color2: '#fe8fb5',
    color3: '#ffbe7b',
    padding: '1px',
  }),
  /** Card / Style-tab animated border (visualization.animatedBorder). */
  animatedBorder: Object.freeze({
    isActive: false,
    color1: '#7c3aed',
    color2: '#fe8fb5',
    color3: '#ffbe7b',
  }),
});

/**
 * Merge API shinyBorder onto defaults without inventing "on" when the field is absent.
 * Create flow already seeds shinyBorder in agent state; edit should only fill when present.
 */
export function resolveShinyBorderState(shinyBorder) {
  if (!shinyBorder || typeof shinyBorder !== 'object') {
    return {
      ...KA_VISUALIZATION_DEFAULTS.shinyBorder,
      isActiveFab: false,
      isActiveBottomBar: false,
    };
  }

  return {
    ...KA_VISUALIZATION_DEFAULTS.shinyBorder,
    isActiveFab: false,
    isActiveBottomBar: false,
    ...shinyBorder,
  };
}

export function normalizeButtonStyleShinyBorder(buttonStyle) {
  if (!buttonStyle || typeof buttonStyle !== 'object') {
    return buttonStyle;
  }

  if (!buttonStyle.shinyBorder) {
    return buttonStyle;
  }

  return {
    ...buttonStyle,
    shinyBorder: resolveShinyBorderState(buttonStyle.shinyBorder),
  };
}

export default KA_VISUALIZATION_DEFAULTS;
